import React from "react";
import * as Icons from "lucide-react";
import { DOCTORS, WHY, T, CONFIG, waLink } from "../../data/content";
import { useLang } from "../../context/i18n";
import { Reveal } from "./Motion";

export const Doctors = () => {
  const { t } = useLang();
  return (
    <section id="doctors" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <Reveal>
          <p className="font-head text-sm font-bold uppercase tracking-widest text-[var(--red)]">03 — {t(T.doctorsTitle)}</p>
          <h2 className="mt-3 font-head text-3xl font-extrabold tracking-tight text-[var(--navy)] sm:text-4xl lg:text-5xl">{t(T.doctorsTitle)}</h2>
        </Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {DOCTORS.map((d, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div data-testid={`doctor-card-${i}`} className="flex flex-col gap-6 rounded-3xl border border-slate-200 bg-[var(--bg-soft)] p-6 sm:flex-row">
                <div className="flex h-40 w-full shrink-0 items-center justify-center rounded-2xl bg-white ring-1 ring-slate-200 sm:w-36">
                  {d.photo ? (
                    <img src={d.photo} alt={`Photograph of ${d.name}`} loading="lazy" className="h-full w-full rounded-2xl object-cover object-top" />
                  ) : (
                    <div className="text-center text-slate-400">
                      <Icons.UserRound size={40} className="mx-auto" />
                      <span className="mt-1 block text-[11px] font-semibold">Photo to be added</span>
                    </div>
                  )}
                </div>
                <div>
                  <h3 className="font-head text-xl font-extrabold tracking-tight text-[var(--navy)]">{d.name}</h3>
                  <p className="mt-1 text-sm font-semibold text-[var(--green)]">{t(d).role}</p>
                  <p className="mt-3 text-sm text-[var(--slate)]">{d.qualifications}</p>
                  {t(d).extra && <p className="mt-2 text-sm text-[var(--slate)]">{t(d).extra}</p>}
                  <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid={`doctor-consult-${i}`}
                     className="mt-4 inline-flex items-center gap-2 rounded-full bg-[var(--navy)] px-5 py-2.5 text-sm font-bold text-white transition-all hover:scale-[1.03]">
                    <i className="fa-brands fa-whatsapp" aria-hidden="true"></i> {t(T.consultSurgeon)}
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="bg-[var(--bg-soft)] py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 lg:grid-cols-2 lg:px-8">
        <Reveal>
          <img src={CONFIG.images.care} alt="Jan Seva Hospital — expert and compassionate care" loading="lazy"
               className="w-full rounded-3xl object-cover ring-1 ring-slate-200" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-head text-sm font-bold uppercase tracking-widest text-[var(--red)]">04 — {t(T.aboutTitle)}</p>
          <h2 className="mt-3 font-head text-3xl font-extrabold tracking-tight text-[var(--navy)] sm:text-4xl">{t(T.aboutTitle)}</h2>
          <p className="mt-5 text-base leading-relaxed text-[var(--slate)] md:text-lg">{t(T.aboutText)}</p>

          <h3 className="mt-10 font-head text-xl font-bold text-[var(--navy)]">{t(T.whyTitle)}</h3>
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
            {WHY.map((w, i) => {
              const Ico = Icons[w.icon] || Icons.Check;
              return (
                <div key={i} data-testid={`why-${i}`} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white text-[var(--green)] ring-1 ring-slate-200">
                    <Ico size={18} />
                  </span>
                  <span className="text-sm font-semibold text-[var(--navy)]">{t(w)}</span>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
